/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { LightlyTrainerPrecisionV3 } from './LightlyTrainerPrecisionV3';
import { LightlyTrainerPrecisionV3FromJSON, LightlyTrainerPrecisionV3FromJSONTyped, LightlyTrainerPrecisionV3ToJSON, } from './LightlyTrainerPrecisionV3';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DockerWorkerConfigV3LightlyTrainer
 *
 */
// create custom validators for the regexes
export interface DockerWorkerConfigV3LightlyTrainer {
    /**
     *
     * #type number
     * #memberof DockerWorkerConfigV3LightlyTrainer
        * @type int
    * @minimum 0
            
         */
    gpus?: number;
    /**
     *
     * #type number
     * #memberof DockerWorkerConfigV3LightlyTrainer
        * @type int
    * @minimum 0
            
         */
    maxEpochs?: number;
    /**
     *
     * #type LightlyTrainerPrecisionV3
     * #memberof DockerWorkerConfigV3LightlyTrainer
        
        
         */
    precision?: LightlyTrainerPrecisionV3;
}
/**
 * Check if a given object implements the DockerWorkerConfigV3LightlyTrainer interface.
 */
export function instanceOfDockerWorkerConfigV3LightlyTrainer(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { LightlyTrainerPrecisionV3Validator, LightlyTrainerPrecisionV3StringifyShape, LightlyTrainerPrecisionV3StringifyShapeProperties, } from './LightlyTrainerPrecisionV3';
export const DockerWorkerConfigV3LightlyTrainerTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerWorkerConfigV3LightlyTrainer => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerWorkerConfigV3LightlyTrainer => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV3LightlyTrainer => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["gpus", "maxEpochs", "precision"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyTrainer",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyTrainer",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerWorkerConfigV3LightlyTrainerTypiaAssertStringify = (input: DockerWorkerConfigV3LightlyTrainer): string => {
    return ((input: any): string => { const assert = (input: any): DockerWorkerConfigV3LightlyTrainer => {
        const __is = (input: any): input is DockerWorkerConfigV3LightlyTrainer => {
            const $io0 = (input: any): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && Math.floor(input.gpus) === input.gpus && (-2147483648 <= input.gpus && input.gpus <= 2147483647) && 0 <= input.gpus) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && Math.floor(input.maxEpochs) === input.maxEpochs && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647) && 0 <= input.maxEpochs) && (undefined === input.precision || 16 === input.precision || 32 === input.precision);
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV3LightlyTrainer => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.gpus || "number" === typeof input.gpus && !Number.isNaN(input.gpus) && (Math.floor(input.gpus) === input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (-2147483648 <= input.gpus && input.gpus <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@type int)",
                    value: input.gpus
                })) && (0 <= input.gpus || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "number (@minimum 0)",
                    value: input.gpus
                })) || $guard(_exceptionable, {
                    path: _path + ".gpus",
                    expected: "(number | undefined)",
                    value: input.gpus
                })) && (undefined === input.maxEpochs || "number" === typeof input.maxEpochs && !Number.isNaN(input.maxEpochs) && (Math.floor(input.maxEpochs) === input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (-2147483648 <= input.maxEpochs && input.maxEpochs <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@type int)",
                    value: input.maxEpochs
                })) && (0 <= input.maxEpochs || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "number (@minimum 0)",
                    value: input.maxEpochs
                })) || $guard(_exceptionable, {
                    path: _path + ".maxEpochs",
                    expected: "(number | undefined)",
                    value: input.maxEpochs
                })) && (undefined === input.precision || 16 === input.precision || 32 === input.precision || $guard(_exceptionable, {
                    path: _path + ".precision",
                    expected: "(16 | 32 | undefined)",
                    value: input.precision
                }));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyTrainer",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV3LightlyTrainer",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerWorkerConfigV3LightlyTrainer): string => {
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{${$tail(`${undefined === input.gpus ? "" : `"gpus":${undefined !== input.gpus ? input.gpus : undefined},`}${undefined === input.maxEpochs ? "" : `"maxEpochs":${undefined !== input.maxEpochs ? input.maxEpochs : undefined},`}${undefined === input.precision ? "" : `"precision":${undefined !== input.precision ? input.precision : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerWorkerConfigV3LightlyTrainerValidatorShape = {
    'gpus': yup.number().integer().min(0),
    'maxEpochs': yup.number().integer().min(0),
    'precision': LightlyTrainerPrecisionV3Validator.optional().default(undefined),
};
export const DockerWorkerConfigV3LightlyTrainerValidator = yup.object().shape(DockerWorkerConfigV3LightlyTrainerValidatorShape);
export const DockerWorkerConfigV3LightlyTrainerStringifyShapeProperties: ObjectSchema['properties'] = {
    'gpus': {
        'type': 'integer',
        'minimum': 0,
    } as unknown as fastJSON.IntegerSchema,
    'maxEpochs': {
        'type': 'integer',
        'minimum': 0,
    } as unknown as fastJSON.IntegerSchema,
    'precision': LightlyTrainerPrecisionV3StringifyShape,
};
export const DockerWorkerConfigV3LightlyTrainerStringifyShape: ObjectSchema = {
    title: 'DockerWorkerConfigV3LightlyTrainer Stringifier',
    type: 'object',
    properties: {
        ...DockerWorkerConfigV3LightlyTrainerStringifyShapeProperties
    },
    required: [],
};
export const DockerWorkerConfigV3LightlyTrainerStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerWorkerConfigV3LightlyTrainerStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerWorkerConfigV3LightlyTrainerStringify: (data: DockerWorkerConfigV3LightlyTrainer) => string = DockerWorkerConfigV3LightlyTrainerStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerWorkerConfigV3LightlyTrainerFromJSON(json: any): DockerWorkerConfigV3LightlyTrainer {
    return DockerWorkerConfigV3LightlyTrainerFromJSONTyped(json, false);
}
export function DockerWorkerConfigV3LightlyTrainerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerWorkerConfigV3LightlyTrainer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'gpus': !exists(json, 'gpus') ? undefined : json['gpus'],
        'maxEpochs': !exists(json, 'maxEpochs') ? undefined : json['maxEpochs'],
        'precision': !exists(json, 'precision') ? undefined : LightlyTrainerPrecisionV3FromJSON(json['precision']),
    };
}
export function DockerWorkerConfigV3LightlyTrainerToJSON(value?: DockerWorkerConfigV3LightlyTrainer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gpus': value.gpus,
        'maxEpochs': value.maxEpochs,
        'precision': LightlyTrainerPrecisionV3ToJSON(value.precision),
    };
}
